import { Pipe, PipeTransform } from '@angular/core';
import { ReconciliationStatus } from '../../../../data/src/lib/entities/treasury.model';

const LABELS: Record<ReconciliationStatus, string> = {
  [ReconciliationStatus.Reconciled]: 'Conciliado',
  [ReconciliationStatus.Pending]: 'Pendente',
  [ReconciliationStatus.Unmatched]: 'Não conciliado',
  [ReconciliationStatus.Exception]: 'Exceção',
};

@Pipe({ name: 'reconciliationStatusLabel', standalone: true, pure: true })
export class ReconciliationStatusLabelPipe implements PipeTransform {
  transform(value: ReconciliationStatus | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return LABELS[value];
  }
}
